import { render, staticRenderFns } from "./DormitorySubsidy.vue?vue&type=template&id=dcccf0a6&scoped=true"
import script from "./DormitorySubsidy.vue?vue&type=script&lang=js"
export * from "./DormitorySubsidy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcccf0a6",
  null
  
)

export default component.exports